import { getList } from '@/axios/api/myOrder'
import moment from 'moment'
const UPDATE_TABLEDATA = 'UPDATE_TABLEDATA'
const UPDATE_TBL_LOADING = 'UPDATE_TBL_LOADING'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'

const state = {
  tableData: [],
  tblLoading: false,
  pager: {
    current: 1,
    size: 10,
    total: 0
  },
  params: {
  }
}
const getters = {
  tableData: state => state.tableData,
  tblLoading: state => state.tblLoading,
  pager: state => state.pager,
  params: state => state.params
}

const mutations = {
  [UPDATE_TABLEDATA] (state, tableData) {
    state.tableData = (tableData || []).map(v => {
      return {
        ...v,
        createTimeText: moment(v.createTime * 1000).format('YYYY-MM-DD')
      }
    })
  },
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_TBL_LOADING] (state, tblLoading) {
    state.tblLoading = tblLoading
  },
  [UPDATE_SEARCH] (state, { pager, params }) {
    state.pager = { ...state.pager, ...pager }
    if (params) state.params = params
  }
}

const actions = {
  // 获取列表数据
  async getListApi ({ commit }, params) {
    commit(UPDATE_TBL_LOADING, true)
    try {
      let { data: res } = await getList(params)
      commit(UPDATE_TABLEDATA, res.records)
      commit(UPDATE_TOTAL, res.total)
    } catch (e) { }
    commit(UPDATE_TBL_LOADING, false)
  },
  // 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/myOrder.js